"use client";

import { resetConsent } from "@/lib/consent";

/** Footer control to re-open the cookie banner and change the analytics choice. */
export function CookieSettingsLink({ className }: { className?: string }) {
  return (
    <button type="button" onClick={() => resetConsent()} className={className}>
      Cookie settings
    </button>
  );
}
